import React, { useState } from 'react';

import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import WelcomeBanner from '../partials/dashboard/WelcomeBanner';
import DashboardAvatars from '../partials/dashboard/DashboardAvatars';
import FilterButton from '../partials/actions/FilterButton';
import Datepicker from '../partials/actions/Datepicker';
import DashboardCard01 from '../partials/dashboard/DashboardCard01';
import Banner from '../partials/Banner';
import { useEffect } from 'react';
import axios from 'axios';
import { UserAuth } from '../context/AuthContext';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Skeleton from 'react-loading-skeleton';

function Dashboard() {
  const { user, logOut } = UserAuth();
  const [subscriptionData, setSubscriptionStatus] = useState([])
  const [countRemaining, setCountRemaining] = useState(0)
  const [apiKey, setApiKey] = useState("")
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {

    const checkIfUserExists = async () => {
      //axios post request with a payload
      let payload = { uid: user.uid }
      console.log(payload)
      const response = await axios.post("https://backend.designbud.app/does_user_exist", payload)
      console.log(response.data.response)


      if (response.data.response === 'User Exists') {
        // dont register
        // const res=await axios.post("https://backend.designbud.app/fetch_user",payload)
        let payload = { email: user.email }

        const response = await axios.post("https://backend.designbud.app/fetch_user_dashboard", payload)
       
       console.log(response.data.response[0])

        setSubscriptionStatus(response.data.response[0])


        setCountRemaining(response.data.response[0].count_remaining)
        setApiKey(response.data.response[0].api_key)
      }
      else {
        //register
        let payload = { uid: user.uid, email: user.email, name: user.displayName, photo_url: user.photoURL }
        console.log(payload)
        console.log("reg user")
        const response = await axios.post("https://backend.designbud.app/create_user", payload)
        console.log(response.data)
        setCountRemaining(5)

        window.location.reload(false);
      }
      setIsLoading(false)
    }
    checkIfUserExists()


  }, [user])

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [copied, setCopied] = useState(false)

  const copyToClipboard = () => {
    setCopied(true)
    console.log("sds")
    toast("You have already voted for this proposal")

  }

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

        {/*  Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">

            {/* Welcome banner */}
            <WelcomeBanner countRemaining={countRemaining} user={user} apiKey={apiKey} loading={isLoading} />

            {/* Dashboard actions */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">



              <span className="font-semibold text-xl  text-blue-800  mr-2 px-6 py-6   dark:text-blue-800">
                
                <div className=' flex  md:flex-row flex-col justify-center items-center'>
                  <div className='md:mb-0 mb-4'>
                    {isLoading ? (<div className="w-20"><Skeleton count={1} /> </div>) : (<span className=' w-80 
                    md:text-lg text-sm'>Your API key is <span className='opacity-95'>{apiKey}</span></span>)}
                  </div>

                  <button onClick={() => toast("sdsds")}>
                    <CopyToClipboard text={apiKey}
                      onCopy={copyToClipboard}
                    >
                      <span className='bg-gradient-to-r from-blue-500 
                       to-teal-400 hover:bg-gradient-to-r hover:from-blue-600
                        hover:to-teal-500 text-white text-sm font-bold py-2 px-4 rounded md:ml-2  cursor-pointer'>Copy to clipboard </span>
                    </CopyToClipboard>
                  </button>
                </div>
              </span>



              {copied ? <span style={{ color: 'red' }}>Copied.</span> : null}


            </div>



            {/* Cards */}
            <div className="grid grid-cols-12 gap-6">

              <DashboardCard01 subscriptionData={subscriptionData} loading={isLoading} />
              {/* <DashboardCard02 />
              <DashboardCard03 />
              <DashboardCard04 />
           <DashboardCard05 />
              <DashboardCard06 />
              <DashboardCard07 />
              <DashboardCard08 />
              <DashboardCard09 />
              <DashboardCard10 />
              <DashboardCard11 />
              <DashboardCard12 />
              <DashboardCard13 /> */}

            </div>

          </div>
        </main>

        <Banner />

      </div>
    </div>
  );
}

export default Dashboard;